<ng-container>
	<form #form="ngForm" fxLayout="column" fxLayoutAlign="space-between" novalidate>
		<mat-card *ngIf="company_url" style="background-color:#525355;margin:32px 8px 8px 8px;">
			<mat-card-header>
				<mat-card-title><span translate>企業URL</span></mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<a [href]="company_url" style="color:#fdfdfd;font-size:18px;font-weight:700;">{{company_url}}</a>
			</mat-card-content>
		</mat-card>
		<div fxLayout="column" fxLayout.gt-sm="row">
			<mat-card style="margin:8px;">
				<mat-card-header>
					<mat-card-title><span translate>所属先企業選択</span></mat-card-title>
				</mat-card-header>
				<mat-card-content>
					<div fxLayout="column" fxLayout.gt-md="row">
						<mat-form-field fxFlex style="margin:30px">
							<mat-label><span translate>manage</span></mat-label>
							<mat-select #manage_select="ngModel" (selectionChange)="onChangeManage()" [(ngModel)]="manage" name="manage_select" required>
								<mat-option *ngFor="let manage of manages" [value]="manage">
									{{manage.nickname}}
								</mat-option>
							</mat-select>
							<mat-error *ngIf="manage_select.errors?.['required'];"><span translate>選択してください</span></mat-error>
						</mat-form-field>

						<mat-form-field fxFlex style="margin:15px">
							<mat-chip-list #columnList aria-label="column">
								<mat-chip (removed)="onRemoveItem(manage.account)" *ngFor="let manage of selected_manages" [removable]="true" [selectable]="true">
									{{manage.account.content.nickname}}
									<mat-icon matChipRemove>cancel</mat-icon>
								</mat-chip>
							</mat-chip-list>
						</mat-form-field>
					</div>
				</mat-card-content>
				<mat-card-actions>
					<div fxLayout="row" fxLayoutAlign="center">
						<button (click)="onAddItem(manage)" [disabled]="(form.invalid || isProgress || !manage)" style="background-color:#8e8e8e;width: 110px;" mat-raised-button>
							<div fxLayout="row" fxLayoutAlign="space-between center">
								<mat-icon fxFlex="30">add_circle</mat-icon>
								<div fxFlex="70" translate>追加</div>
							</div>
						</button>
					</div>
				</mat-card-actions>
			</mat-card>
			<belongs-panel style="margin:8px" #belongs_panel [auth]="auth" [account]="account"></belongs-panel>
		</div>
	</form>
</ng-container>
